
import React, { PropTypes } from 'react';

import './style.scss';

const SidebarGroup = props => {

  return (
    <div className="SidebarGroup">
      <h3>{props.title}</h3>

      {props.children}
    </div>
  );
};

SidebarGroup.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  title: PropTypes.string
};

export default SidebarGroup;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Sidebar/SidebarGroup/index.js
 **/